
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sorting-quiz",
      function () {
        return require("private-next-pages/sorting-quiz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sorting-quiz"])
      });
    }
  